export default __webpack_public_path__ + "static/media/my-portfolio.05d6ad54.svg";